module.exports = "/_next/static/images/feature3-abd676720a4b2cafca8ae6cd278a85b0.png";